import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Popup } from "@/Common/Components/Modals/Popup";
import { PrintHelper } from "@/Common/Helpers/PrintHelper";
import { SignaturePinControl } from "./SignaturePinControl";

interface IPrintAndSignaturePopupProps {
    previewPdfUrl: string;
    hasPin?: boolean;
    hasMessage?: boolean;
    labelButton?: string;
    onClose: () => void;
    onSuccessPin?: () => void;
    onRejectPin?: () => void;
    onPrint?: () => void;
    onSign?: () => void;
}

class PrintAndSignaturePopupState {
    public pinHasBeenValidated: boolean;

    public static getDefault(): PrintAndSignaturePopupState {
        const state = new PrintAndSignaturePopupState();
        state.pinHasBeenValidated = false;
        return state;
    }
}

class PrintAndSignaturePopup extends BaseReactComponent<IPrintAndSignaturePopupProps, PrintAndSignaturePopupState> {
    constructor(props: IPrintAndSignaturePopupProps) {
        super(props);
        this.state = PrintAndSignaturePopupState.getDefault();
    }

    public componentWillReceiveProps(nextProps: IPrintAndSignaturePopupProps, nextState: PrintAndSignaturePopupState): boolean {
        return (
            this.state.pinHasBeenValidated != nextState.pinHasBeenValidated
            || this.props.previewPdfUrl != nextProps.previewPdfUrl
        );
    }

    public render(): JSX.Element {
        let previewPath = this.props.previewPdfUrl ? PrintHelper.GetPreviewPath(this.props.previewPdfUrl) : "";

        return (
            <Popup
                cssClass="preview-fax-iframe-popup"
                topPosition={20}
                title=""
                onCloseDelegate={() => this.props.onClose()}
                draggable={true}
            >
                <div className="generic-print-sign-popup">
                    <div className="p-body">
                        <iframe id="iframe-pdf-document" src={previewPath} height="710" width="520" />
                    </div>
                    <div className="footer" style={{ "display": "inline" }}>
                        <div style={{ "float": "left", "marginTop": "5px" }}>
                            {this.props.hasMessage && (
                                <label style={{ fontStyle: "italic" }}>
                                    {cacheStore.GetString("OriginalSignatureWillBeAddedLabel")}
                                </label>
                            )}
                        </div>
                        <div style={{ "float": "right", "display": "inline-flex", "marginBottom": "5px" }}>
                            {(this.props.hasPin && sessionStore.signOnPrintAccess) && (
                                <div className="push-right-5">
                                    <SignaturePinControl
                                        onSuccessFunction={() => this.onPinSuccess()}
                                        onRejectFunction={() => this.onPinReject()}
                                    />
                                </div>
                            )}
                            <button
                                className="btn btn-default push-right-5"
                                onClick={() => this.props.onClose()}
                            >
                                <span>{cacheStore.GetString("CancelLabel")}</span>
                            </button>
                            {this.props.onPrint && (
                                <button
                                    disabled={false}
                                    className="btn btn-primary push-right-5"
                                    onClick={() => this.onPrint()}
                                >
                                    <span>{cacheStore.GetString(this.props.labelButton || "PrintPlanLabel")}</span>
                                </button>
                            )}
                            {(this.props.onSign && this.props.hasPin && sessionStore.signOnPrintAccess && cacheStore.ClinicSettings.EnableSignedAuthorization) && (
                                <button
                                    disabled={this.state.pinHasBeenValidated}
                                    className="btn btn-primary push-right-5"
                                    onClick={() => this.onSign()}
                                >
                                    <span>{cacheStore.GetString("SignLabel")}</span>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </Popup>

        );
    }

    private onPinSuccess(): void {
        this.mutateState(s => s.pinHasBeenValidated = true, this.props.onSuccessPin);
    }

    private onPinReject(): void {
        this.mutateState(s => s.pinHasBeenValidated = false, () => this.props.onRejectPin?.());
    }

    private onPrint(): void {
        this.props.onPrint?.();
    }

    private onSign(): void {
        this.props.onSign?.();
    }
}

export { PrintAndSignaturePopup as PrintAndSignaturePopup };
